import { PHYSICAL_EXAM_SECTION_INITIAL_VALUES } from "./physical-exams";

export const GENITOURINARY_FORM_INITIAL_VALUES = {
  sections: {
    vulvaAndPerineum: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
    rectum: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
    vagina: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
    cervix: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
    uterusAndAdnexa: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
    pelvicFloor: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
  },
  notes: "",
};

export type PhysicalExamGenitourinarySections =
  keyof typeof GENITOURINARY_FORM_INITIAL_VALUES.sections;
